import React from 'react';
import { MdBlock, MdCenterFocusStrong } from "react-icons/md";
import { FiMove } from "react-icons/fi";
import { TbRotate } from "react-icons/tb";
import { Localization } from "@viamap/viamap2-common";

export function ActionSelector(props: { activeTool: string, setActiveTool: (s: string) => void, onCapture?: () => void, children?: React.ReactNode }) {
   const { activeTool, setActiveTool, onCapture, children } = props;
   return (
      <div className="Horizontal_Radio_Button_group">
         <button data-info={Localization.getText("Inactive")} className={activeTool == "none" ? "active" : ""} onClick={() => setActiveTool("none")} ><MdBlock /></button>
         <button data-info={Localization.getText("Move")} className={activeTool == "move" ? "active" : ""} onClick={() => setActiveTool("move")} ><FiMove /></button>
         <button data-info={Localization.getText("Rotate")} className={activeTool == "rota" ? "active" : ""} onClick={() => setActiveTool("rota")} ><TbRotate /></button>

         {children ? (
            <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 8 }}>{children}</div>
         ) : (
            <button data-info={Localization.getText("Capture")} style={{ marginLeft: "auto" }} onClick={() => onCapture && onCapture()} ><MdCenterFocusStrong /></button>
         )}
      </div>
   )
}

export default ActionSelector;
